// NOTE: This file centralises shared configuration and helper functions
// used across components. Keep it dependency‑light (no React imports).

export const CATEGORIES = [
  'All',
  'Market Stats',
  'Regulation',
  'Casino',
  'Sportsbook',
  'Tax & Compliance',
  'Industry Voices',
];

export const POPULAR_THEMES = [
  'Channelisation',
  'Tax uplift',
  'KYC & AML',
  'White licence lists',
  'Player protection',
];

// Theme label used for influencer/interview-style posts.
export const INDUSTRY_VOICES_THEME = 'Industry Voices';

export const MAIN_NAV_ITEMS = [
  { label: 'All news', category: 'All' },
  { label: 'Market stats', category: 'Market Stats' },
  { label: 'Regulation', category: 'Regulation' },
  { label: 'Casino', category: 'Casino' },
  { label: 'Sportsbook', category: 'Sportsbook' },
  { label: 'Tax & compliance', category: 'Tax & Compliance' },
];

// Client-side fallback images for posts by category, used when a post
// has no imageUrl stored in Firestore (e.g. older posts) or when the
// remote image fails to load. These are hosted background-style images
// themed around casino / sportsbook / regulation.
export const CATEGORY_FALLBACK_IMAGES = {
  'Market Stats':
    'https://images.unsplash.com/photo-1518131678677-bc1a4dca4ccb?auto=format&fit=crop&w=1200&q=80',
  Regulation:
    'https://images.unsplash.com/photo-1531297484001-80022131f5a1?auto=format&fit=crop&w=1200&q=80',
  Casino:
    'https://images.unsplash.com/photo-1518131678677-bc1a4dca4ccb?auto=format&fit=crop&w=1200&q=80',
  Sportsbook:
    'https://images.unsplash.com/photo-1542751371-adc38448a05e?auto=format&fit=crop&w=1200&q=80',
  'Tax & Compliance':
    'https://images.unsplash.com/photo-1554224154-22dec7ec8818?auto=format&fit=crop&w=1200&q=80',
  'Industry Voices':
    'https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1200&q=80',
  default:
    'https://images.unsplash.com/photo-1518131678677-bc1a4dca4ccb?auto=format&fit=crop&w=1200&q=80',
};

export function getFallbackImageForArticle(article) {
  if (!article) return CATEGORY_FALLBACK_IMAGES.default;
  const key =
    article.category && CATEGORY_FALLBACK_IMAGES[article.category]
      ? article.category
      : 'default';
  return CATEGORY_FALLBACK_IMAGES[key];
}

// Used to detect "fallback-only" posts which should be treated as unpublished drafts.
export const FALLBACK_IMAGE_URLS = Object.freeze(
  Array.from(new Set(Object.values(CATEGORY_FALLBACK_IMAGES)))
);

export function isFallbackImageUrl(url) {
  const u = String(url || '').trim();
  if (!u) return false;
  return FALLBACK_IMAGE_URLS.includes(u);
}

export const API_BASE = process.env.REACT_APP_API_BASE_URL || '';
export const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://igamingspot.net';
export const THEME_STORAGE_KEY = 'igamingnews-theme';

// Admin login (Firebase Auth). We intentionally do NOT store passwords in code or Firestore.
// - Username is a UI convenience; we map it to an email for Firebase Auth.
export const ADMIN_USERNAME = process.env.REACT_APP_ADMIN_USERNAME || 'admin';
export const ADMIN_EMAIL = process.env.REACT_APP_ADMIN_EMAIL || 'yevhenms@gmail.com';

// Footer content (SEO + brand)
export const FOOTER_ABOUT_TEXT =
  process.env.REACT_APP_FOOTER_ABOUT_TEXT ||
  'IGAMINGSPOT provides regulated iGaming news, market context, and operator perspectives from around the globe.';
export const FOOTER_CONTACT_EMAIL =
  process.env.REACT_APP_FOOTER_CONTACT_EMAIL || 'contact@igamingspot.net';

// Social links (set to real URLs via env vars; empty links are hidden)
export const SOCIAL_LINKS = [
  { key: 'facebook', label: 'Facebook', href: process.env.REACT_APP_SOCIAL_FACEBOOK || '' },
  { key: 'instagram', label: 'Instagram', href: process.env.REACT_APP_SOCIAL_INSTAGRAM || '' },
  { key: 'linkedin', label: 'LinkedIn', href: process.env.REACT_APP_SOCIAL_LINKEDIN || '' },
  { key: 'x', label: 'X', href: process.env.REACT_APP_SOCIAL_X || '' },
  { key: 'telegram', label: 'Telegram', href: process.env.REACT_APP_SOCIAL_TELEGRAM || '' },
  { key: 'youtube', label: 'YouTube', href: process.env.REACT_APP_SOCIAL_YOUTUBE || '' },
  { key: 'rss', label: 'RSS', href: process.env.REACT_APP_SOCIAL_RSS || '' },
];

export function formatDate(value) {
  if (!value) return '';

  let d;
  if (typeof value === 'string') {
    d = new Date(value);
  } else if (value?.toDate) {
    d = value.toDate();
  } else {
    d = new Date(value);
  }

  return d.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}


